import config from '../config';

declare global {
    interface Window {
      heap: any;
    }
}
export const initHeap = () => {
  const HEAP_APP_ID = config.HEAP_APP_ID;

  (function() {
    window.heap = window.heap || [];
    window.heap.load = function(e: string, t?: any) {
      window.heap.appid = e;
      window.heap.config = t = t || {};
      const r = document.createElement("script");
      r.type = "text/javascript";
      r.async = true;
      r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";
      const a = document.getElementsByTagName("script")[0];
      a.parentNode?.insertBefore(r, a);

      const n = function(method: string) {
        return function(...args: any[]) {
          window.heap.push([method, ...args]);
        };
      };

      const methods = [
        "addEventProperties", "addUserProperties", "clearEventProperties",
        "identify", "resetIdentity", "removeEventProperty",
        "setEventProperties", "track", "unsetEventProperty"
      ];

      for (let i = 0; i < methods.length; i++) {
        window.heap[methods[i]] = n(methods[i]);
      }
    };

    window.heap.load(HEAP_APP_ID);
  })();
};
